module.exports = __webpack_public_path__ + "img/step7.d31ac658.png";